import React, { useEffect, useState }  from 'react';
import BasicView from '../components/BasicView';
import auth from '../../../service/Auth';
import { get_participant_variant, getOMIMInfo } from '../../../service/apis';
import ViewError from '../components/ViewError';
import Typography from '@mui/material/Typography';

const config = window.config;

const TaggedVariants = (props) => {

    const [headers, setHeaders] = useState([]);
    const [variants, setVariants] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const [headersTable, setHeadersTable] = useState([]);
    const [rowsTable, setRowsTable] = useState([]);
    const [omimTerms, setOmimTerms] = useState("");
    const [errors, setErrors] = useState("");

    useEffect(() => {
        if (auth.tokenExpired()) {
            // Logging check
            setErrors("Logging session timeout. Please log again");
        }
        else {
            //Define Headers
            setHeaders([
                { label: "Experiment ID" , key: "sample"},
                { label: "User", key: "user" },
                { label: "CHROM", key: "chromosome",tooltip: "Chromosome, identifier from the reference genome."},
                { label: "POS", key: "start_pos",tooltip: "The reference position, within each reference sequence CHROM." },
                { label: "REF", key: "ref",tooltip: "Reference base(s)." },
                { label: "ALT", key: "alt",tooltip: "Alternate base(s)." },
                { label: "Gene", key: "gene_name" },
                { label: "Significance", key: "significance" },
                { label: "Inheritance", key: "inheritance" },
                { label: "Comments", key: "comments" },
                { label: "Zygosity", key: "zygosity" },
                { label: "OMIM", key: "omim" }
            ]);
        }
    },[])

    const loadTableData = async(state,instance) => {
        // Set Load Process
        setLoadData(true);
        /* Get Tagged Variants */
        get_participant_variant(auth.getToken(),config.pheno_api_endpoint, props.location.participant_id)
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            // 1. Get the OMIMs
            if(data.data!== undefined){
                // 1.1 Get variants information                
                let snvs = [];
                for (let item of data.data) {
                    for (let object of item) {
                        snvs.push(object);
                    }
                }

                // 1.2 Extract all array and then do promises
                const promises = snvs.map( item => {
                    if('gene_name' in item) {
                        return getOMIMInfo(config.domain + "/genomics_service", item.gene_name,  auth.getToken())
                        .then(response=> {
                            const mydata = response.json();
                            return mydata;
                        });
                    }
                });

                Promise.all(promises).then(promise => {
                    if(promise!== undefined){
                        const _omims = promise.map(result => {
                            if(result!== undefined){
                                const geneMapList = result.omim.searchResponse.entryList[0].entry.geneMap;
                                if (geneMapList !== undefined){
                                    if (geneMapList.phenotypeMapList){
                                        return geneMapList.phenotypeMapList.map(x => ({Phenotype: x.phenotypeMap.phenotype, Inheritance: x.phenotypeMap.phenotypeInheritance}))
                                    }else{
                                        return "NA"
                                    }
                                }
                            }
                            else {
                               return "NA"
                            }
                        });
                        //let data_w_omim = data.data.map((d,i) => { let item = d; item.omim= _omims[i]; return item});
                        let data_w_omim = snvs.map((d,i) => { let item = d; item.omim= _omims[i]; return item});
                        setOmimTerms(_omims);
                        setVariants(data_w_omim);
                    }
                });
                //let records = (Array.isArray(data.data)) ? data.data : [];
                let records = (Array.isArray(snvs)) ? snvs : [];
                setVariants(records);
                setLoadData(false);
            }
        })
    }

    const getTableHeaders = () => {
        // Set headers table view 
        let columns = [];
        for (let header of headers) {
            let column = {};
            if ("tooltip" in header){
                column["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
            }
            else{
                column["Header"] = header.label;
            }
            column["accessor"] = header.key;
            columns.push(column);
        }
        setHeadersTable(columns);
    }

    const getDataTable = () => {
        //Build row table view 
        let data = [];
        for (let rowData of variants){
            let row = {};
            // Loop Headers
            for (let column of headersTable){
                if (column.accessor in rowData) {
                    if ( column.accessor == "omim" ) {
                        row[column.accessor] = JSON.stringify(rowData[column.accessor]);
                    } 
                    else{
                        row[column.accessor] = rowData[column.accessor];
                    }
                    
                } else {
                    row[column.accessor] = "unknown";
                }
            }
            data.push(row);
        }
        setRowsTable(data);   
    }

    const getTitle = () => {
        if (props.location.participant_id !== undefined){
            return (  
                <Typography variant={"h5"} align={"center"}>
                    {"List of Tagged Variants for "}
                    <a href={config.domain + "/phenostore/#/summary/" + props.location.participant_id} target={"blank"}>
                        {props.location.participant_id}
                    </a>
                </Typography>);
        }
        else{
            return <Typography variant={"h5"} align={"center"}> No Participant Selected </Typography>;
        }
    } 

    useEffect(() => {
        // Set headers
        getTableHeaders();
    },[variants])

    useEffect(() => {
        // Set rows
        getDataTable();
    },[headersTable])

    if (errors !== "") {
        // Show popup in case an error with the loggin occurs 
        return <ViewError closeModal={closeModal} title={"Logging Error"} message={errors}/>;
    }
    else {
        return (
            <div className={"mainContent"}>
                {getTitle()}
                <BasicView goBack={"#/experimentanalysisstatus"}
                           headers={headers}
                           columns={headersTable}
                           data={rowsTable}
                           loading={loadData}
                           onFetchData={loadTableData}
                />
            </div>
        );
    }
}
export default TaggedVariants;
